export default "__VITE_ASSET__CpUyA$Hf__"